import { createContext, Dispatch, SetStateAction } from 'react';

// ifr reconciliation
export interface ContextIfrReconciliationProps {
	values: Record<string, Record<string, number>>;
	setValues: Dispatch<SetStateAction<Record<string, Record<string, number>>>>;
}

export const ContextIfrReconciliation = createContext<ContextIfrReconciliationProps>({
	values: {},
	setValues: () => {
		console.log('SET IFR RECONCILIATION VALUES');
	},
});

// ifr forecast
export interface ContextIfrForecastProps {
	values: Record<string, Record<string, number>>;
	setValues: Dispatch<SetStateAction<Record<string, Record<string, number>>>>;
}

export const ContextIfrForecast = createContext<ContextIfrForecastProps>({
	values: {},
	setValues: () => {
		console.log('SET IFR FORECAST VALUES');
	},
});
